<template>
  <span
    class="price-input"
    :class="{ saved: saved !== null }"
  >
    <input
      v-model="value"
      type="number"
      min="0"
      step="0.01"
      :placeholder="$t('configurator.price_placeholder')"
      @keyup.enter="save"
      @click.stop
    >
    <button
      type="button"
      :disabled="!valid"
      :title="$t('configurator.save_price')"
      @click.stop="save"
    >
      <feather-icon
        icon="CheckIcon"
        size="13"
      />
    </button>
  </span>
</template>

<script>
// Precio de una línea pendiente (sin tarifa) que pone Tecnitex al revisar la oferta
export default {
  props: {
    line: {
      type: Object,
      required: true,
    },
  },
  data() {
    // Si ya tiene precio manual, se precarga para poder corregirlo
    const atributos = JSON.parse(this.line.atributos || '{}')
    return {
      value: atributos.manual_price ? String(this.line.amount) : '',
    }
  },
  computed: {
    valid() {
      return this.value !== '' && Number(this.value) > 0 && Number(this.value) !== this.saved
    },
    saved() {
      return JSON.parse(this.line.atributos || '{}').manual_price ? Number(this.line.amount) : null
    },
  },
  methods: {
    save() {
      if (!this.valid) return
      this.$emit('save', { line: this.line, amount: Number(this.value) })
    },
  },
}
</script>

<style lang="scss" scoped>
.price-input {
  display: inline-flex;
  align-items: center;
  gap: .25rem;
  input {
    width: 90px;
    height: 26px;
    padding: 0 .4rem;
    border: 1px solid #ff9f43;
    border-radius: 5px;
    background: #fffbeb;
    font-size: .78rem;
    text-align: right;
    outline: none;
    &:focus {
      border-color: #ac1a19;
    }
  }
  &.saved input {
    border-color: #b8c2cc;
    background: #fff;
  }
  button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border: 1px solid #3a7d44;
    border-radius: 5px;
    background: #3a7d44;
    color: #fff;
    cursor: pointer;
    &:disabled {
      opacity: .4;
      cursor: not-allowed;
    }
  }
}
</style>
